<template>
  <router-view></router-view>
</template>
<script>
// if (process.env.VUE_APP_LOCAL !== 'Q' && process.env.VUE_APP_LOCAL !== 'C') {
//   // 针对tujia平台的首屏加载性能上报
//   const { getTfmClient } = require('@tujia/fe_falcon')
//   getTfmClient('feccms.tujia.com').setPId(1002)
//   window.onload = function() {
//     setTimeout(() => {
//       getTfmClient('feccms.tujia.com').info({ path: 'webPerfLog' })
//     })
//   }
// }
export default {

}
</script>
